import React from 'react';
import { Helmet } from 'react-helmet';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'; // FontAwesome icons

// ContactInfo component to display individual contact details (Location, Phone, Email)
const ContactInfo = ({ icon, title, text, link }) => {
  return (
    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 contact-info-column text-center">
      <div className="contact-info-icon">
        {icon} {/* Using FontAwesome icons directly here */}
      </div>
      <h4>{title}</h4>
      <p className="fnt-17">
        {link ? <a href={link}>{text}</a> : text}
      </p>
    </div>
  );
};

// Main Contact component to render all contact-related sections
const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services</title>
        <meta name="description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
        <meta name="keywords" content="Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services" />
        <meta property="og:description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
        <meta property="og:image" content="https://anjalienterprisesindia.com/images/office-partition-service.jpg" />
        <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-glass-office-partition" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Anjali Enterprises" />
      </Helmet>

      {/* Banner Section */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="contact-banner-image" />
        <div className="banner-caption">
          <h1>Contact Us</h1>
          <ul className="breadcumb">
            <li><a href="#">Home</a> - </li>
            <li>Contact Us</li>
          </ul>
        </div>
      </div>

      {/* Contact Section */}
      <section className="pad100-top-bottom">
        <div className="container pt-5">
          <div className="row pt-5">
            {/* Contact Info */}
            <ContactInfo 
              icon={<FaPhoneAlt size={40} />} 
              title="Phone" 
              text="+91 8793220265" 
              link="tel:+918793220265" 
            />
            <ContactInfo 
              icon={<FaEnvelope size={40} />} 
              title="Email" 
              text="info@anjalienterprisesindia.com" 
              link="mailto:info@anjalienterprisesindia.com" 
            />
            <ContactInfo 
              icon={<FaMapMarkerAlt size={40} />} 
              title="Anjali Enterprises" 
              text="Shop No 7 Vishal Deep Residency M Perk, Nagar Highway, Chandan Nagar-Vadgaon Sheri, Pune - 411014"
            />
          </div>
        </div>
      </section>

      {/* Google Maps Section */}
      <div className="contact_map">


      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1538.4935886174787!2d73.93324340671968!3d18.560772465498047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1b0b5e249ef%3A0x30d3355d77b6b44d!2sAnjali%20enterprises!5e1!3m2!1sen!2sin!4v1742963107704!5m2!1sen!2sin" width="auto" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


      </div>
    </div>
  );
};

export default Contact;
